<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div v-if="targetingCriteria != null && targetingCriteria.filter((x) => !x.isUpdatePushedExternally).length > 0">
    <div
      v-show="isVisible"
      :class="{ 'form-section-content': wrappedInPane }">
      <div class="form-group row">
        <form-label :is-required="false">{{ capitalize($t('messages.uvTargeting')) }} </form-label>
        <div class="col-sm-8">
          <div class="form-group row">
            <div class="col-sm-12 edit-uv-targeting-conditions-toggle">
              <toggle-button
                :color="colors.success"
                :value="enableUVTargeting"
                :disabled="isReadOnly"
                :labels="{
                  checked: capitalize(i18n.global.t('actions.yes')),
                  unchecked: capitalize(i18n.global.t('actions.no')),
                }"
                :sync="true"
                @change="
                  () => {
                    enableUVTargeting = !enableUVTargeting;
                  }
                " />
            </div>
          </div>
          <div class="form-group row">
            <div
              v-show="enableUVTargeting"
              class="col-sm-12 scale-vertical">
              <div class="mb-3">
                {{ $t('messages.thisLineItemWillBeActiveDuringTheFollowingSelectedUVConditions') }}
              </div>
              <div class="uv-conditions">
                <stepped-slider
                  :steps="allUVs"
                  :selected-steps="internalSelectedUVConditions"
                  @changed="onUVSelectionChanged" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { capitalize } from 'vue';

  import Colors from '@/Colors';
  import { FormLabel, SteppedSlider } from '@/common/components/controls';
  import i18n from '@/vueI18n';

  import allUVs from './UVTargetingEnumerations';

  export default {
    name: 'UvTargeting',
    components: {
      FormLabel,
      SteppedSlider,
    },
    props: {
      selectedUVConditions: {
        type: Array,
        default: () => [],
      },
      isReadOnly: {
        type: Boolean,
        default: false,
      },
      targetingCriteria: {
        type: Array,
      },
      wrappedInPane: {
        type: Boolean,
        default: true,
      },
      isVisible: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        allUVs: allUVs(),
        colors: Colors,
        enableUVTargeting: false,
        i18n,
        internalSelectedUVConditions: null,
      };
    },
    watch: {
      selectedUVConditions(val) {
        if (val != null && val.length > 0) {
          this.enableUVTargeting = true;
          this.internalSelectedUVConditions = this.allUVs.filter((x) => val.find((y) => y.localeCompare(x.id) === 0));
        } else {
          this.enableUVTargeting = false;
          this.internalSelectedUVConditions = null;
        }
      },
      enableUVTargeting(val) {
        if (val) {
          if (this.selectedUVConditions == null) {
            if (this.isReadOnly) {
              return;
            }
            this.$emit('selectedUVConditionsChanged', [...this.allUVs.map((x) => x.id)]);
          }
        } else {
          this.internalSelectedUVConditions = null;

          if (this.isReadOnly) {
            return;
          }
          this.$emit('selectedUVConditionsChanged', null);
        }
      },
    },
    mounted() {
      this.enableUVTargeting = this.selectedUVConditions != null && this.selectedUVConditions.length > 0;

      if (this.enableUVTargeting) {
        this.internalSelectedUVConditions = this.allUVs.filter((x) =>
          this.selectedUVConditions.find((y) => y.localeCompare(x.id) === 0),
        );
      }
    },
    methods: {
      capitalize(s) {
        return capitalize(s);
      },
      onUVSelectionChanged(x) {
        if (this.isReadOnly) {
          return;
        }
        this.$emit('selectedUVConditionsChanged', x.length === 0 ? null : x.map((y) => y.id));
      },
      validate() {
        if (this.isReadOnly) {
          return true;
        }
        const extras = {};
        if (this.enableUVTargeting && this.internalSelectedUVConditions.length === 0) {
          extras.targetingCriteriaUVConditions = {
            message: i18n.global.t('messages.pleaseSelectAtLeastOneUVCondition'),
            preEvaluated: true,
          };
        }
        return extras;
      },
    },
  };
</script>
